import { Link, useLocation } from 'react-router-dom';
import { House, Newspaper, Radio, UserRound } from 'lucide-react';
import { useAuth } from '../../lib/auth';
import { useI18n } from '../../lib/i18n';

export default function MobileBottomNav() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const { t } = useI18n();

  const accountTarget = user ? (user.role === 'admin' || user.role === 'editor' ? '/admin' : '/profil') : '/connexion';

  const items = [
    { to: '/', icon: House, label: t('mobile.home', 'Accueil') },
    { to: '/categorie/actualites', icon: Newspaper, label: t('mobile.news', 'Actualités') },
    { to: '/radio', icon: Radio, label: t('mobile.radio', 'Radio') },
    { to: accountTarget, icon: UserRound, label: t('mobile.account', 'Compte') },
  ];

  return (
    <nav
      className="md:hidden mobile-fixed-nav z-50 border-t border-[#ddd6fe] bg-[#fbfaff]/95 backdrop-blur-xl shadow-[0_-12px_24px_rgba(91,33,182,0.08)]"
      style={{ paddingBottom: 'max(6px, env(safe-area-inset-bottom))' }}
      data-testid="mobile-bottom-nav"
    >
      <div className="grid grid-cols-4">
        {items.map((item) => {
          const Icon = item.icon;
          const active = pathname === item.to || (item.to !== '/' && pathname.startsWith(item.to));
          return (
            <Link
              key={item.to}
              to={item.to}
              className={`flex flex-col items-center justify-center py-2 gap-1 text-[10px] transition-colors ${
                active ? 'text-[#7c3aed]' : 'text-gray-500'
              }`}
              data-testid={`mobile-nav-${item.to.replace(/[^a-z0-9]+/gi, '-').toLowerCase()}`}
            >
              <Icon size={18} />
              <span className="font-semibold uppercase tracking-[0.08em]">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
